import React, { useEffect, useState } from 'react'
import { Alert, Button, Form, Table } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { fetchFixes, fetchNoDataSymbols, fetchSnp500, submitNoDataFix } from '../reducers/snp500Slice'

const COLUMNS = [
  { key: 'Symbol', label: 'Symbol' },
  { key: 'Security', label: 'Name' },
  { key: 'GICS Sector', label: 'Sector' },
  { key: 'GICS Sub-Industry', label: 'Sub-Industry' },
  { key: 'Headquarters Location', label: 'Headquarters' },
  { key: 'Date added', label: 'Date Added' },
  { key: 'CIK', label: 'CIK' },
  { key: 'Founded', label: 'Founded' },
]

function Snp500NoDataTab() {
  const dispatch = useDispatch()
  const noDataSymbols = useSelector((state) => state.snp500.noDataSymbols)
  const noDataLoading = useSelector((state) => state.snp500.noDataLoading)
  const noDataError = useSelector((state) => state.snp500.noDataError)

  const [replacements, setReplacements] = useState({})
  const [submitErrors, setSubmitErrors] = useState({})

  useEffect(() => {
    dispatch(fetchNoDataSymbols())
  }, [dispatch])

  function setReplacement(symbol, value) {
    setReplacements((prev) => ({ ...prev, [symbol]: value }))
  }

  async function handleSubmit(symbol) {
    const replacement = (replacements[symbol] ?? '').trim()
    if (!replacement) return
    try {
      await dispatch(submitNoDataFix({ original: symbol, replacement })).unwrap()
      setSubmitErrors((prev) => {
        const next = { ...prev }
        delete next[symbol]
        return next
      })
      dispatch(fetchNoDataSymbols())
      dispatch(fetchFixes())
      dispatch(fetchSnp500())
    } catch (err) {
      setSubmitErrors((prev) => ({ ...prev, [symbol]: err.message || 'Submit failed' }))
    }
  }

  if (noDataLoading) {
    return <div className="text-muted small py-3">Loading…</div>
  }

  if (noDataError) {
    return <Alert variant="danger">{noDataError}</Alert>
  }

  if (noDataSymbols.length === 0) {
    return (
      <div className="text-center py-5 text-muted">
        <p className="mb-0">No unresolved symbols.</p>
      </div>
    )
  }

  return (
    <Table responsive hover size="sm">
      <thead>
        <tr>
          {COLUMNS.map(({ label }) => (
            <th key={label}>{label}</th>
          ))}
          <th>Fix</th>
        </tr>
      </thead>
      <tbody>
        {noDataSymbols.map((item) => (
          <tr key={item.Symbol}>
            {COLUMNS.map(({ key }) => (
              <td key={key}>{item[key] || '—'}</td>
            ))}
            <td>
              <div className="d-flex gap-2 align-items-center">
                <Form.Control
                  type="text"
                  size="sm"
                  placeholder="Replacement symbol"
                  value={replacements[item.Symbol] ?? ''}
                  onChange={(e) => setReplacement(item.Symbol, e.target.value)}
                  aria-label={`Replacement for ${item.Symbol}`}
                />
                <Button
                  size="sm"
                  variant="primary"
                  onClick={() => handleSubmit(item.Symbol)}
                >
                  Submit
                </Button>
              </div>
              {submitErrors[item.Symbol] && (
                <Alert variant="danger" className="mb-0 mt-1 py-1 px-2 small">
                  {submitErrors[item.Symbol]}
                </Alert>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  )
}

export default Snp500NoDataTab
